import { render, staticRenderFns } from "./ciam-logout.vue?vue&type=template&id=2319abb5&"
import script from "./ciam-logout.vue?vue&type=script&lang=js&"
export * from "./ciam-logout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports